import { buildSafeCanonicalUrl } from '../../../../../../utils/build-safe-canonical-url';

export const buildProfileUrl = (
  baseUrl: string,
  profilePath: string,
): string => {
  const safeBaseUrl = typeof baseUrl === 'string' ? baseUrl : '';
  const safeProfilePath = typeof profilePath === 'string' ? profilePath : '';

  return buildSafeCanonicalUrl(safeBaseUrl, safeProfilePath);
};
